module.exports = __webpack_public_path__ + "img/emerg-contraception.cf5b33d8.jpg";